
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/gen-saif",
      function () {
        return require("private-next-pages/[lang]/gen-saif/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/gen-saif"])
      });
    }
  